import { datadogLogs } from '@datadog/browser-logs';

import { runtimeEnv } from './runtime-parser';

datadogLogs.init({
  clientToken: runtimeEnv.DD_CLIENT_TOKEN || '',
  env: runtimeEnv.DD_LOG_ENV || 'preproduction',
  forwardErrorsToLogs: false,
  sampleRate: parseInt(runtimeEnv.DD_LOG_SAMPLE_RATE, 10) || 10,
  service: 'sigil',
});

export default datadogLogs.logger;
